import { render, staticRenderFns } from "./TheList.vue?vue&type=template&id=220cbeb8"
import script from "./TheList.vue?vue&type=script&lang=js"
export * from "./TheList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports